// extracted by mini-css-extract-plugin
export var animationContainer = "_e3-0";
export var asteriskIcon = "_e3-8";
export var conversationLeftSection = "_e3-4";
export var conversationListItem = "_e3-3";
export var conversationMiddleSection = "_e3-5";
export var conversationRightSection = "_e3-6";
export var detailsContent = "_e3-1";
export var listContainer = "_e3-7";
export var modalContent = "_e3-2";